import React, { Component } from "react";

// import Typography from '@material-ui/core/Typography';

import CategoriesFunction from "./categoriesFunction";
import { withFirebase } from "../../../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import withAuthorization from "../../../Session/withAuthorization";

import Navigation from "../../../Navigation";

const CategoriesPage = () => {
  return (
    <>
      <Navigation content={<CategoriesForm />} />
    </>
  );
};

class CategoriesPageBase extends Component {
  render() {
    return (
      <>
        <CategoriesFunction props={this.props} />
        <label
          variant="caption"
          style={{
            display: "block",
            marginBottom: "auto",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          Copyright &copy; {new Date().getFullYear()} RAMPVER. All rights
          reserved.
        </label>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const CategoriesForm = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase
)(CategoriesPageBase);

export default CategoriesPage;

export { CategoriesForm };
